module.exports = __webpack_public_path__ + "static/media/Brands_15.9925b50a.png";